import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from "lodash";
import SweetAlert from 'react-bootstrap-sweetalert';
import { AgGridReact } from '@ag-grid-community/react';
import "@ag-grid-enterprise/all-modules/dist/styles/ag-grid.css";
import "@ag-grid-enterprise/all-modules/dist/styles/ag-theme-balham.css";
import 'react-datetime/css/react-datetime.css';
import CSVFileValidator from 'csv-file-validator';
import $ from 'jquery';
//import 'jquery-ui/ui/core';
import 'jquery-ui/ui/widgets/datepicker';
var redirectURL = require('../redirectURL');
var moment = require('moment');
export default class PlantMaster extends Component {
    state = {
        show: false,
        basicTitle: '',
        basicType: "default",
        loadshow: "show-n",
        overly: "show-n",
        rowData: [],
        pivotmodeis: false,
        pivotcols: [],
        defaultColDef: {
            sortable: true,
            filter: true,
            resizable: true

        },
        sliderforeditplant:false,
        opDealer: {
  id: "",
  plant_code: "",
  plant_name: "",
  plant_address: "",
  consigner_latitude: "",
  consigner_longitude: ""
},

        frameworkComponents: {
        },
        rowModelhighchartoptionsType: 'enterprise',
        rowGroupPanelShow: 'always',
        animateRows: true,
        debug: true,
        showToolPanel: true,
        suppressAggFuncInHeader: true,
        statusBar: {
            statusPanels: [
                {
                    statusPanel: "agTotalAndFilteredRowCountComponent",
                    align: "left"
                },
                {
                    statusPanel: "agTotalRowCountComponent",
                    align: "center"
                },
                { statusPanel: "agFilteredRowCountComponent" },
                { statusPanel: "agSelectedRowCountComponent" },
                { statusPanel: "agAggregationComponent" }
            ]
        },
        sideBar: {
            toolPanels: [
                {
                    id: "columns",
                    labelDefault: "Columns",
                    labelKey: "columns",
                    iconKey: "columns",
                    toolPanel: "agColumnsToolPanel"
                },
                {
                    id: "filters",
                    labelDefault: "Filters",
                    labelKey: "filters",
                    iconKey: "filter",
                    toolPanel: "agFiltersToolPanel"
                }
            ]
        },
        csvcontent: [],
        file: '',
        slider: 'show-n'
    }
    componentDidMount() {
        this.loadData()
    }
    loadData = () => {
        redirectURL.post("/masters/getPlantsMaster", {},{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': localStorage.getItem("userid")
              }
          }).then(res => {
            let respData = res.data
            this.setState({
                rowData: respData.plantMasters,
            })
        })
    }
    closeAlert = () => {
        this.setState({
            show: false,
            basicType: "",
            basicTitle: ""
        })
    }
    onGridReady = params => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
    };
    onGridState = () => {
        this.colState = this.gridColumnApi.getColumnState();
        this.rowGroupState = this.gridColumnApi.getRowGroupColumns();
        this.pivotColumns = this.gridColumnApi.getPivotColumns();
        window.filterState = this.gridApi.getFilterModel();
        this.gridApi.setFilterModel(window.filterState);
    }
    changeTptFileHandler = async (e) => {
        if(e.target.files.length !== 0){
            const config = {
                headers: [
                    {
                        name: 'plant_name',
                        inputName: 'plant_name',
                        required: true,
                        requiredError: function (headerName, rowNumber, columnNumber) {
                            return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                        }
                    },
                    {
                        name: 'plant_code',
                        inputName: 'plant_code',
                        required: true,
                        requiredError: function (headerName, rowNumber, columnNumber) {
                            return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                        }
                    },
                    {
                        name: 'plant_address',
                        inputName: 'plant_address',
                        required: false,
                        requiredError: function (headerName, rowNumber, columnNumber) {
                            return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                        }
                    },
                    {
                        name: 'consigner_latitude',
                        inputName: 'consigner_latitude',
                        required: false,
                        requiredError: function (headerName, rowNumber, columnNumber) {
                            return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                        }
                    },   
                    {
                        name: 'consigner_longitude',
                        inputName: 'consigner_longitude',
                        required: false,
                        requiredError: function (headerName, rowNumber, columnNumber) {
                            return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                        }
                    },                
                    // {
                    //     name: 'remarks',
                    //     inputName: 'remarks',
                    //     required: true,
                    //     requiredError: function (headerName, rowNumber, columnNumber) {
                    //         return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                    //     }
                    // }
                ]
            }
            const aplhanumeichypen = new RegExp(/^[a-zA-Z0-9 -.,/@&_]*$/); // define allowed characters using regex
            const validNumber = new RegExp(/^[0-9]*$/);
            const validText = new RegExp(/^[a-zA-Z &@._]*$/);
            const validFloat = new RegExp(/^[-?\d{1,2}\.\d{8}]*$/);
            const validAddress = new RegExp(/^[a-zA-Z0-9()-_/#@&,. :]+$/);
            
            var data = CSVFileValidator(e.target.files[0], config)
                .then((csvData) => {
                    console.log('csvData', csvData)
                    // if (csvData.inValidMessages.length > 0) {
                    //     this.setState({
                    //         show: true,
                    //         basicTitle : 'dont upload other fields',
                    //         basicType : 'danger'
                    //     });
                    // }else{
                    //     this.setState({
                    //         csvcontent: csvData.data
                    //     });
                    // }
                    let keys = Object.keys(csvData.data[0])
                    let items = ['plant_name','plant_code','plant_address','consigner_latitude','consigner_longitude']
                    let check = false
                    if(csvData.inValidMessages.length === 0)
                    {
                        for (let i in keys){
                            // console.log("items.includes(keys[i]) ", items.includes(keys[i]))
                            if(items.includes(keys[i])){                 
                                check = true             
                            }else{
                                check = false
                                break
                            }
                        }
                    }
                    else{
                        check = false
                        
                    }
                    var mobMes  = 1;
                    var textMes= 1;
                    var numMes = 1;
                    var floatMes = 1;
                    var addressMes = 1;
                    // let csvalues = Object.values(csvData.data[0])
                    // if(csvalues.length > 0)
                    // {
                    //     for(let c in csvalues)
                    //     {
                    //         // console.log("csvalues value ",csvalues[c])
                    //         // console.log("aplhanumeichypen",aplhanumeichypen.test(csvalues[c])+"  "+csvalues[c])
                    //         if(aplhanumeichypen.test(csvalues[c]) === false)
                    //         {
                    //             check = false;
                    //             break;
                    //         }
                    //     }
                    // }
                    
                    let csvaluesarr = Object.values(csvData.data)
                    // console.log("csvalues", csvaluesarr)
                    if(csvaluesarr.length > 0)
                    {
                        for(var a=0;a<csvaluesarr.length; a++)
                        {
                            var csvalues = Object.values(csvaluesarr[a])
                            for(var c in csvalues)
                            {
                                //  console.log("aplhanumeichypen",validNumber.test(csvalues[c])+"  "+csvalues[c])
                                //  console.log("csvalues value ",c+"====="+validNumber.test(csvalues[c].trim()))
                                // if(parseInt(c) === 1)
                                // {
                                //     if(validNumber.test(csvalues[c]) === false)
                                //     {
                                //         check = false;
                                //         numMes = 0
                                //         break;
                                //     }
                                // }
                                //  console.log("csvalues value ",c+"====="+csvalues[c])
                                //   console.log("aplhanumeichypen",validFloat.test(csvalues[c])+"  "+csvalues[c])
                                //   console.log("csvalues value ",c+"====="+validFloat.test(csvalues[c].trim()))
                                // if(parseInt(c) === 3 || parseInt(c) === 4)
                                // {
                                //     if(validFloat.test(csvalues[c]) === false)
                                //     {
                                //         check = false;
                                //         floatMes = 0
                                //         break;
                                //     }
                                // }
                                //  console.log("aplhanumeichypen",validAddress.test(csvalues[c])+"  "+csvalues[c])
                                //  console.log("csvalues value ",c+"====="+validAddress.test(csvalues[c].trim()))
                                // if(parseInt(c) === 2)
                                // {
                                //     if(validAddress.test(csvalues[c]) === false)
                                //     {
                                //         check = false;
                                //         addressMes = 0
                                //         break;
                                //     }
                                // }
                                // console.log("aplhanumeichypen",aplhanumeichypen.test(csvalues[c])+"  "+csvalues[c])
                                // console.log("csvalues value ",c+"====="+aplhanumeichypen.test(csvalues[c].trim()))
                                // if(parseInt(c) === 0 )
                                // {
                                    if(aplhanumeichypen.test(csvalues[c]) === false)
                                    {
                                        check = false;
                                        break;
                                        }
                                    // }
                            }
                        }
                    }

                     console.log("check", check)
                    if (check === false) {
                        $("#uploadFile").val("")
                        // document.getElementById("appednCSVData").innerHTML = ''
                        // if(parseInt(textMes) === 0 )
                        // {
                        //     this.setState({
                        //         show: true,
                        //         basicTitle: 'Invalid  Name added',
                        //         basicType: 'danger'
                        //     });
                        // }    
                        //  if(parseInt(numMes) === 0 )
                        // {
                        //     this.setState({
                        //         show: true,
                        //         basicTitle: 'Invalid  Number added',
                        //         basicType: 'danger'
                        //     });
                        // }
                        // else if(parseInt(floatMes) === 0 )
                        // {
                        //     this.setState({
                        //         show: true,
                        //         basicTitle: 'Invalid float Number added',
                        //         basicType: 'danger'
                        //     });
                        // }
                        // else if(parseInt(addressMes) === 0 )
                        // {
                        //     this.setState({
                        //         show: true,
                        //         basicTitle: 'Invalid Address added',
                        //         basicType: 'danger'
                        //     });
                        //  }
                        {
                            this.setState({
                                show: true,
                                basicTitle: 'dont upload other fields or special characters',
                                basicType: 'danger'
                            });
                        }    
                    } else {
                        this.setState({
                            csvcontent: csvData.data
                        });
                    }
                    
                }).catch(err => { })
            // console.log("e.target.files[0]",e.target.result);
            var contentList = []
    
            var out = new Promise(function (reject, resolve) {
                var reader = new FileReader();
                reader.onload = async function (e) {
                    var contents = await e.target.result;
                    // document.getElementById("appednCSVData").innerHTML = contents
                    resolve(contents);
                };
                var tt = reader.readAsText(e.target.files[0]);
            });
            // console.log(contentList);
            this.setState({
                file: e.target.files[0]
            });
            // console.log("e.target.files[0].type ", e.target.files[0]);
    
            if (e.target.files[0].type == 'text/csv' || e.target.files[0].type == 'application/vnd.ms-excel') {
                // console.log(fileData);
                // console.log(typeof(fileData))
    
            }
            else {
                e.target.value = null;
                this.setState({
                    uploadFile: '',
                    file: "",
                    show: true,
                    basicType: 'danger',
                    basicTitle: 'Please upload file having extensions .csv only.',
                });
            }
        }
    }

    uploadBulkFormHandler = e => {
        e.preventDefault()
        const { csvcontent } = this.state
        if(csvcontent.length >0){
            redirectURL.post("/masters/uploadPlantMasterData", csvcontent,{
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': localStorage.getItem("userid")
                  }
              }).then(res => {
                if (res.data.message === 'success') {
                    document.getElementById("upform").reset()

                    this.setState({
                        slider: "show-n",
                        csvcontent: [],
                        file: '',
                        overly: "show-n",
                        loadshow: 'show-n',
                        show:true ,
                        basicTitle:'success',
                        basicType:'success',
                    
                    })
                    setTimeout(() =>{
                        this.loadData()
                    }, 1000)                    
                }
            })
        }else{
            this.setState({
                show: true,
                basicTitle: 'cant enter empty data',
                basicType : 'danger'
            })
        }

    }

    bulkUploadTptMaster = () => {
        this.setState({
            slider: 'slider-translate-40p',
            overly: "show-m",
            loadshow: 'show-n'
        })
    }
    resetUpload = () => {
        document.getElementById("upform").reset()
    }

    onClickHideAll = () => {
        $("#uploadFile").val("")
        this.setState({
            loadshow: 'show-n',
            overly: 'show-n',
            slider: "",
        });
    }
onCloseSlider=()=>{
    this.setState({

    })
}
updatePlantHandler = (e) => {
    e.preventDefault();

    const { plant_code, plant_name, plant_address, consigner_latitude, consigner_longitude } = this.state.opDealer

    if (plant_code && plant_name) {
        const payload = {
            plant_code,
            plant_name,
            plant_address,
            consigner_latitude,
            consigner_longitude
        };

        redirectURL.post("/masters/updatePlantMasterData", payload, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("userid")
            }
        }).then(res => {
            if (res.data.message === "success") {
                this.setState({
                    slider: "show-n",
                    plant_code: "",
                    plant_name: "",
                    plant_address: "",
                    consigner_latitude: "",
                    consigner_longitude: "",
                    show: true,
                    basicTitle: "Plant updated successfully",
                    sliderforeditplant:false,
                     overly: "show-n",
            loadshow: 'show-n',
                    basicType: "success"
                });

                setTimeout(() => {
                    this.loadData();
                }, 1000);
            }
        }).catch(err => {
            this.setState({
                show: true,
                basicTitle: "Update failed",
                basicType: "danger"
            });
            console.error("Error in updatePlantHandler", err);
        });

    } else {
        this.setState({
            show: true,
            basicTitle: "Plant code & name are required",
            basicType: "danger"
        });
    }
};

    onCellClicked = (e) => {
        if (e.colDef.field == "delete") {
            var rowId = e.data._id;
            // console.log("delete",e.data);
            var qry = {
                rowId: rowId,
                collection : 'master_plants',
                email : localStorage.getItem('email')
            }
            //var confirm = confirm("Are You Sure! Do you want really delete?");
            if (window.confirm("Are You Sure! Do you want really delete?")) {
                redirectURL.post("/masters/deleteRowData", qry,{
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': localStorage.getItem("userid")
                      }
                  }).then((response) => {
                    // console.log("response",response);
                    if (response.data.status == "success") {
                        this.setState({
                            basicTitle: "Deleted Successfully.",
                            basicType: "success",
                            show: true
                        })
                        //window.location.reload();
                        setTimeout(() =>{
                            this.loadData()
                        }, 1000)
                    }
                    else {
                        this.setState({
                            basicTitle: "Failed to Delete.",
                            basicType: "warning",
                            show: true
                        })
                    }
                }).catch((e) => {
                    console.log(e);
                })
            }
        }
      else if (e.colDef.field == "edit") {
  let data = e.data;
  this.setState({
    sliderforeditplant: true,
    opDealer: {
      id: data._id,
      plant_code: data.plant_code,
      plant_name: data.plant_name,
      plant_address: data.plant_address,
      consigner_latitude: data.consigner_latitude,
      consigner_longitude: data.consigner_longitude
    }
  });
   this.setState({
            overly: "show-m",
            loadshow: 'show-n'
        })
}

}
    render() {
        const { show, basicType, basicTitle, rowData, modules, defaultColDef, statusBar, slider, loadshow, overly } = this.state
        const plantsColumnDefs = [
            {
                headerName: "Plant Name",
                field: "plant_name",
                width: 150,
                filter: "agSetColumnFilter",
                resizable: true,
            },
            {
                headerName: "Plant Code",
                field: "plant_code",
                width: 130,
                filter: "agSetColumnFilter",
                resizable: true,
            },
            {
                headerName: "Plant Address",
                field: "plant_address",
                width: 100,
                filter: "agSetColumnFilter",
                resizable: true,               
            },
            {
                headerName: "Plant Latitude",
                field: "consigner_latitude",
                width: 130,
                filter: "agSetColumnFilter",
                resizable: true,
            }, 
            {
                headerName: "Plant Longitude",
                field: "consigner_longitude",
                width: 130,
                filter: "agSetColumnFilter",
                resizable: true,
            },               
            {
                pinned: "left",
                headerName: "",
                field: "delete",
                width: 50,
                resizable: true,
                editable: false,
                cellRenderer: params => {
                    return '<i class="icofont icofont-ui-delete"></i>';
                },
                filter: false,
            },
             {
                pinned: "left",
                headerName: "",
                field: "edit",
                width: 50,
                resizable: true,
                editable: false,
                cellRenderer: params => {
                    return '<i class="icofont icofont-ui-edit"></i>';
                },
                filter: false,
            }
        ]
        return (
            <div className="container-fluid">
                <SweetAlert
                    show={show}
                    type={basicType}
                    title={basicTitle}
                    onConfirm={this.closeAlert}
                >
                </SweetAlert>
                <div className='row'>
                    <div className="card col-xl-12 col-lg-12">
                        <div className="card-header" style={{ padding: '10px' }}>
                            <h4>Plant Master</h4>
                            <div className="row">
                                <div className="col-sm-12">
                                    <button className="float-right btn btn-warning" onClick={this.bulkUploadTptMaster}>
                                        Bulk Upload
                                    </button>
                                   
                                </div>
                            </div>
                        </div>
                        <div className="height-equal equal-height-lg" style={{ padding: '10px' }}>
                            <div className="card-body" style={{ padding: '10px' }}>
                                <div id="myGrid" style={{ height: "400px" }} className="ag-theme-balham">
                                    <AgGridReact
                                        modules={modules}
                                        columnDefs={plantsColumnDefs}
                                        defaultColDef={defaultColDef}
                                        rowData={rowData}
                                        enableCharts={false}
                                        enableRangeSelection={true}
                                        statusBar={statusBar}
                                        pagination={true}
                                        groupHeaderHeight={40}
                                        headerHeight={40}
                                        floatingFiltersHeight={50}
                                        pivotGroupHeaderHeight={30}
                                        pivotHeaderHeight={50}
                                        rowHeight={40}
                                        onGridReady={this.onGridReady}
                                        onGridState={this.onGridState}
                                        onCellClicked={this.onCellClicked}                                    />
                                </div>

                            </div>

                        </div>
                        <div className={"dataLoadpage " + (this.state.loadshow)}>
                        </div>
                        <div className={"dataLoadpageimg " + (this.state.loadshow)}>
                            <div class="loader-box"><div class="loader-box"><div class="rotate dashed colored"></div></div></div>
                        </div>
                        <div className={"overlay-part " + (this.state.overly)} onClick={this.onClickHideAll}></div>


                    </div>
                      <div
  className={"slide-r " + (this.state.sliderforeditplant ? "slider-translate-30p" : "")}
  style={{ right: "0px" }}
>
  <h3 className="subH">
    Edit Plant
    <span
      className="float-right closebtn"
      onClick={() => this.setState({ sliderforeditplant: false,overly:'show-n' })}
      style={{ cursor: "pointer" }}
    >
      X
    </span>
  </h3>
  <div className="slide-r-body relative-container">
    <div className="container-fluid">
      <form className="theme-form" onSubmit={this.updatePlantHandler}>
        <div className="form-group">
          <label>Plant Code <span className="err-txt">*</span></label>
          <input
            type="text"
            className="form-control"
            value={this.state.opDealer.plant_code}
            readOnly
          />
        </div>

        <div className="form-group">
          <label>Plant Name <span className="err-txt">*</span></label>
          <input
            type="text"
            className="form-control"
            value={this.state.opDealer.plant_name}
            onChange={(e) =>
              this.setState({ opDealer: { ...this.state.opDealer, plant_name: e.target.value } })
            }
            required
          />
        </div>

        <div className="form-group">
          <label>Plant Address</label>
          <input
            type="text"
            className="form-control"
            value={this.state.opDealer.plant_address}
            onChange={(e) =>
              this.setState({ opDealer: { ...this.state.opDealer, plant_address: e.target.value } })
            }
          />
        </div>

        <div className="form-group">
          <label>Latitude</label>
          <input
            type="text"
            className="form-control"
            value={this.state.opDealer.consigner_latitude}
            onChange={(e) =>
              this.setState({ opDealer: { ...this.state.opDealer, consigner_latitude: e.target.value } })
            }
          />
        </div>

        <div className="form-group">
          <label>Longitude</label>
          <input
            type="text"
            className="form-control"
            value={this.state.opDealer.consigner_longitude}
            onChange={(e) =>
              this.setState({ opDealer: { ...this.state.opDealer, consigner_longitude: e.target.value } })
            }
          />
        </div>

        <div className="form-group d-flex justify-content-end" style={{ gap: "10px" }}>
          <button
            type="button"
            className="btn btn-default"
            onClick={() => this.setState({ sliderforeditplant: false,overly:'show-n' })}
          >
            Cancel
          </button>
          <button type="submit" className="btn btn-success">
            Update
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

                        {/* tpt bulk upload  */}
                        <div className={"slide-r " + (slider)} style={{ overflow: "hidden" }}>
                            <h3 className="subH">Bulk Upload Plant Data
                            <span className="float-right closebtn" style={{ marginRight: "25px" }} onClick={this.onClickHideAll} >X</span>

                            </h3>
                            <div className="slide-r-body relative-container">
                                <div className="container-fluid">
                                    <form method="POST" id="upform" className="theme-form" onSubmit={this.uploadBulkFormHandler}>

                                        <div className="form-group mt-20p">
                                            <label className="">Upload File</label>
                                            <input type="file" id="uploadFile" name="uploadFile" onChange={this.changeTptFileHandler} className="form-control" required />
                                            <div style={{color:"#ff0000",marginTop:"10px"}}>
                                                ** Allowed Space and Special Characters are 
                                                <span style={{fontWeight:"700", fontSize:"18px", fontFamily:"arial"}}>
                                                    -._,&#</span>
                                            </div>
                                        </div>
                                        {/* <div className='p-2' id="appednCSVData"></div> */}
                                        <div className="form-group">
                                            <button type="submit" className="btn btn-success">Submit</button>
                                            <button type="button" onClick={this.resetUpload} className="btn btn-default">Cancel</button>
                                        </div>
                                    </form>
                                    {/* <p className='pl-3' style={{ color: 'red' }}> please format the dates in yyyy-mm-dd hh:mm:ss or dd-mm-yyyy hh:mm:ss before uploading</p> */}
                                    <div className="form-group">
                                        <a className="btn btn-primary" href={require('../../assets/json/bulk_master_plant.csv')} target="_blank">Sample Template</a>

                                    </div>
                                </div>
                            </div>
                        </div>
                </div>

            </div>
        )
    }
}